(() => {
  const ROOT_SELECTOR = '[data-paths-product]';

  function initPathsProduct(root) {
    if (!root || root.dataset.pathsProductInitialized === 'true') return;

    root.dataset.pathsProductInitialized = 'true';

    const form = root.querySelector('[data-paths-product-form]');
    const addButton = root.querySelector('[data-paths-add-to-cart]');
    const addLabel = root.querySelector('[data-paths-add-label]');
    const status = root.querySelector('[data-paths-product-status]');
    const viewCart = root.querySelector('[data-paths-view-cart]');

    const variantSelect = root.querySelector('[data-paths-variant-select]');
    const price = root.querySelector('[data-paths-product-price]');

    const mobileAtc = root.querySelector('[data-paths-mobile-atc]');
    const mobileAdd = root.querySelector('[data-paths-mobile-add]');
    const mobilePrice = root.querySelector('[data-paths-mobile-price]');

    const toast = root.querySelector('[data-paths-product-toast]');

    const thumbnails = root.querySelectorAll('[data-paths-product-thumbnail]');
    const mediaSlides = root.querySelectorAll('[data-paths-product-media]');

    let toastTimer = null;


    function showMedia(mediaId) {
      mediaSlides.forEach((slide) => {
        const active = slide.dataset.pathsProductMedia === String(mediaId);

        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });

      thumbnails.forEach((thumbnail) => {
        const active =
          thumbnail.dataset.pathsProductThumbnail === String(mediaId);

        thumbnail.classList.toggle('is-active', active);
        thumbnail.setAttribute('aria-pressed', String(active));
      });
    }


    function showToast() {
      if (!toast) return;

      window.clearTimeout(toastTimer);

      toast.classList.add('is-visible');

      toastTimer = window.setTimeout(() => {
        toast.classList.remove('is-visible');
      }, 2600);
    }


    async function updateCartCount() {
      try {
        const response = await fetch(`${window.routes.cart_url}.js`, {
          headers: {
            Accept: 'application/json',
          },
        });

        if (!response.ok) return;

        const cart = await response.json();

        document
          .querySelectorAll('[data-paths-cart-count]')
          .forEach((counter) => {
            counter.textContent = cart.item_count;

            counter.classList.toggle(
              'paths-header__cart-count--empty',
              cart.item_count === 0
            );
          });
      } catch (error) {
        console.error('Unable to update cart count:', error);
      }
    }


    function updateVariantUI() {
      if (!variantSelect) return;

      const option = variantSelect.options[variantSelect.selectedIndex];

      if (!option) return;

      const available = option.dataset.available === 'true';
      const variantPrice = option.dataset.price;
      const comparePrice = option.dataset.comparePrice;

      if (price) {
        price.innerHTML = '';

        if (comparePrice && comparePrice !== variantPrice) {
          const compare = document.createElement('span');

          compare.className = 'paths-product__compare-price';
          compare.textContent = comparePrice;

          price.appendChild(compare);
        }

        const current = document.createElement('span');

        current.className = 'paths-product__current-price';
        current.textContent = variantPrice;

        price.appendChild(current);
      }

      if (mobilePrice) {
        mobilePrice.textContent = variantPrice;
      }

      if (addButton) {
        addButton.disabled = !available;
      }

      if (mobileAdd) {
        mobileAdd.disabled = !available;
        mobileAdd.textContent = available ? 'Add to cart' : 'Sold out';
      }

      if (addLabel) {
        addLabel.textContent = available ? 'Add to cart' : 'Sold out';
      }
    }


    async function submitProduct() {
      if (!form || !addButton || addButton.disabled) return;

      addButton.classList.add('is-loading');
      addButton.disabled = true;

      if (mobileAdd) {
        mobileAdd.disabled = true;
      }

      if (status) {
        status.textContent = '';
      }

      try {
        const formData = new FormData(form);

        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
          },
          body: formData,
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(
            result.description ||
            result.message ||
            'Unable to add this Path to your cart.'
          );
        }

        if (addLabel) {
          addLabel.textContent = 'Added ✓';
        }

        if (viewCart) {
        viewCart.classList.add('is-visible');
        }

        showToast();
        await updateCartCount();

        window.setTimeout(() => {
          if (addLabel) {
            addLabel.textContent = 'Add to cart';
          }
        }, 1800);

      } catch (error) {
        if (status) {
          status.textContent = error.message;
        }
      } finally {
        addButton.classList.remove('is-loading');

        const selectedOption =
          variantSelect?.options[variantSelect.selectedIndex];

        const available = selectedOption
          ? selectedOption.dataset.available === 'true'
          : true;

        addButton.disabled = !available;

        if (mobileAdd) {
          mobileAdd.disabled = !available;
        }
      }
    }


    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        showMedia(thumbnail.dataset.pathsProductThumbnail);
      });
    });


    variantSelect?.addEventListener('change', updateVariantUI);


    form?.addEventListener('submit', (event) => {
      event.preventDefault();

      submitProduct();
    });


    mobileAdd?.addEventListener('click', () => {
      submitProduct();
    });


    if (mobileAtc && addButton) {
  let addButtonHasBeenSeen = false;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        addButtonHasBeenSeen = true;
        mobileAtc.classList.remove('is-visible');
        return;
      }

      if (addButtonHasBeenSeen) {
        mobileAtc.classList.add('is-visible');
      }
    },
    {
      threshold: 0.15,
    }
  );

  observer.observe(addButton);
}


    updateVariantUI();
  }


  function initAllPathsProducts(root = document) {
    root
      .querySelectorAll(ROOT_SELECTOR)
      .forEach(initPathsProduct);
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAllPathsProducts();
    });
  } else {
    initAllPathsProducts();
  }


  document.addEventListener('shopify:section:load', (event) => {
    initAllPathsProducts(event.target);
  });
})();